// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");

function parenCntStackPush(cnt, i) {
  if (cnt.stack.length === cnt.len) {
    for(var _for = 1; _for <= 1000; ++_for){
      cnt.stack.push(0);
    }
  }
  cnt.stack[cnt.len] = i;
  cnt.len = cnt.len + 1 | 0;
}

function parenCntMake(parenMin, canBeFirstMin, canBeFirstMax, canBeLastMin, canBeLastMax) {
  if (parenMin % 2 !== 0) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "mod(parenMin, 2)  != 0 in parenCntMake"
          },
          Error: new Error()
        };
  }
  return {
          stack: new Array(1000),
          len: 0,
          failed: false,
          parenMin: parenMin,
          canBeFirstMin: canBeFirstMin,
          canBeFirstMax: canBeFirstMax,
          canBeLastMin: canBeLastMin,
          canBeLastMax: canBeLastMax
        };
}

function parenCntReset(cnt) {
  cnt.len = 0;
  cnt.failed = false;
}

function parenCntPut(cnt, i) {
  if (cnt.failed) {
    return "Failed";
  }
  if (!(cnt.parenMin <= i && i < 0)) {
    if (cnt.len === 0) {
      return "Balanced";
    } else {
      return "Opened";
    }
  }
  var isOpen = i % 2 === -1;
  if (isOpen) {
    parenCntStackPush(cnt, i);
    return "Opened";
  } else if (cnt.len === 0 || cnt.stack[cnt.len - 1 | 0] !== (i + 1 | 0)) {
    cnt.failed = true;
    return "Failed";
  } else {
    cnt.len = cnt.len - 1 | 0;
    if (cnt.len === 0) {
      return "Balanced";
    } else {
      return "Opened";
    }
  }
}

function parenCntCanBeFirst(cnt, i) {
  if (0 <= i || cnt.parenMin < i && i % 2 === -1) {
    return true;
  } else if (cnt.canBeFirstMin <= i) {
    return i <= cnt.canBeFirstMax;
  } else {
    return false;
  }
}

function parenCntCanBeLast(cnt, i) {
  if (0 <= i || cnt.parenMin <= i && i % 2 === 0) {
    return true;
  } else if (cnt.canBeLastMin <= i) {
    return i <= cnt.canBeLastMax;
  } else {
    return false;
  }
}

exports.parenCntMake = parenCntMake;
exports.parenCntReset = parenCntReset;
exports.parenCntPut = parenCntPut;
exports.parenCntCanBeFirst = parenCntCanBeFirst;
exports.parenCntCanBeLast = parenCntCanBeLast;
/* Common Not a pure module */
